<div
  class="h-24 max-w-screen-ssxl mx-auto"
  [ngClass]="[lastItemBgClass()]"
></div>
<div
  class="w-full bg-ss-charleston-green border-t border-solid border-ss-gold relative max-w-screen-ssxl mx-auto"
>
  <div class="-top-[54px] left-0 right-0 absolute flex justify-center">
    <div class="max-w-screen-ssxl w-full px-8 lg:px-32">
      <div
        class="rounded-2xl"
        [ngClass]="
          lastItemBgClass() === 'bg-white' ? 'bg-[#F6F6F6]' : 'bg-white'
        "
      >
        <ss-www-stay-in-touch></ss-www-stay-in-touch>
      </div>
    </div>
  </div>
  <ss-www-desktop-footer class="hidden lg:flex w-full"></ss-www-desktop-footer>
  <ss-www-mobile-footer class="flex lg:hidden"></ss-www-mobile-footer>
</div>
